import React from "react";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

const CalcolaForm = ({
  formData,
  errors,
  onInputChange,
  onPrivacyChange,
  onCalcolaClick,
  onReset,
}) => {
  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 3,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      }}
    >
      <CardContent sx={{ p: 4 }}>
        <Stack direction="row" spacing={1} alignItems="center" mb={3}>
          <FavoriteRoundedIcon color="success" fontSize="large" />
          <Typography variant="h5" fontWeight={700}>
            Calcola il tuo Preventivo
          </Typography>
        </Stack>

        <TextField
          fullWidth
          label="Data di Nascita"
          type="date"
          value={formData.dataNascita}
          onChange={onInputChange("dataNascita")}
          variant="outlined"
          required
          error={errors.dataNascita}
          helperText={
            errors.dataNascita
              ? "Inserisci Data di Nascita"
              : "Età compresa tra 18 e 74 anni"
          }
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            max: new Date(new Date().setFullYear(new Date().getFullYear() - 18))
              .toISOString()
              .split("T")[0],
            min: new Date(new Date().setFullYear(new Date().getFullYear() - 74))
              .toISOString()
              .split("T")[0],
          }}
          sx={{ mb: 2 }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={formData.privacyAccettata}
              onChange={onPrivacyChange}
            />
          }
          label={
            <Typography variant="body2">
              Ho letto e accetto l'
              <Typography
                component="span"
                variant="body2"
                sx={{ color: "#13b86d", fontWeight: 600 }}
              >
                informativa sulla privacy
              </Typography>
            </Typography>
          }
          sx={{ mb: 2 }}
        />
        {errors.privacyAccettata && (
          <Typography
            variant="caption"
            color="error"
            sx={{ display: "block", mb: 2, ml: 1.75 }}
          >
            Devi accettare l'informativa sulla privacy
          </Typography>
        )}

        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={onCalcolaClick}
          endIcon={<ArrowForwardRoundedIcon />}
          sx={{
            bgcolor: "#13b86d",
            "&:hover": { bgcolor: "#10ac7d" },
            py: 1.5,
          }}
        >
          Calcola Preventivo
        </Button>
        
        <Button
          fullWidth
          variant="outlined"
          size="large"
          onClick={onReset}
          sx={{
            mt: 1,
            py: 1.5,
          }}
        >
          Reset Campi
        </Button>
      </CardContent>
    </Card>
  );
};

export default CalcolaForm;
